var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessageDelivered = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.713 10.0213C109.783 9.28614 112.455 12.2301 111.427 15.2145L89.9629 77.5018C89.1174 79.9554 86.1955 80.9667 84.0141 79.5608L19.369 37.8956C16.4094 35.9882 17.1802 31.4635 20.6044 30.6435L106.713 10.0213Z",
    fill: "#DAE0E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4999 22.8239L42.9999 83.8239L42.4999 52.3239L96.4999 22.8239Z",
    fill: "#8599AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4999 59.8239L110 11.3239L43.0107 83.8239L53.4999 59.8239Z",
    fill: "#52667A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110 11.3239L84.4999 79.8239L60.9999 64.8239L53.4999 59.8239L110 11.3239Z",
    fill: "#DAE0E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.401 97.6475C121.401 108.141 112.895 116.647 102.401 116.647C91.908 116.647 83.4014 108.141 83.4014 97.6475C83.4014 87.1541 91.908 78.6475 102.401 78.6475C112.895 78.6475 121.401 87.1541 121.401 97.6475Z",
    fill: "#349872"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.554 90.7162C109.234 89.9171 110.434 89.8205 111.233 90.5003C112.032 91.1803 112.129 92.3798 111.449 93.179L99.7648 106.913L93.3542 99.3775C92.6744 98.5783 92.771 97.3794 93.57 96.6995C94.3692 96.0196 95.5687 96.1161 96.2487 96.9153L99.7642 101.048L108.554 90.7162Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 67.5017L18 75.2961M29.4852 54.3237L3.5 69.3237M18.4846 47.3237L3 56.2641",
    stroke: "#DAE0E7",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageDelivered);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/messageDelivered.5fa2d6080838d0aaa64040b069e086a0.svg";